import type { JSONContent } from '@tiptap/react';

/** Default names from @tiptap-pro/extension-comments, which useThreads also relies on. */
export const INLINE_THREAD_MARK = 'inlineThread';
export const BLOCK_THREAD_NODE = 'blockThread';

function stripNode(node: JSONContent): JSONContent[] {
    const content = node.content?.flatMap(stripNode);
    if (node.type === BLOCK_THREAD_NODE) {
        return content ?? [];
    }
    const marks = node.marks?.filter(mark => mark.type !== INLINE_THREAD_MARK);
    const stripped: JSONContent = { ...node };
    if (content) {
        stripped.content = content;
    }
    if (marks) {
        if (marks.length > 0) {
            stripped.marks = marks;
        } else {
            delete stripped.marks;
        }
    }
    return [stripped];
}

/**
 * Removes comment thread marks and unwraps comment thread blocks, so creating, deleting or
 * resolving a comment does not show up as a document change in a diff.
 */
export function stripCommentMarkup(doc: JSONContent): JSONContent {
    return stripNode(doc)[0] ?? doc;
}
